import { setLayoutToCurrentPage } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
// import GetStarted from "../GetStarted";
import Button from "@builder/components/general/Button";
import OliverText from "@builder/components/general/OliverText";
// import { setCurrentPopup } from "@builder/store/slices/popupSlice";
import AddElemPlus from "../AddElemPlus";
import layoutMap from "./layouts/layoutMap";

import "./style.scss";
import { openLeftSidebar, setLeftInstance } from "@builder/store/slices/sidebarSlice";

const LayoutItem = ({ layoutKey, setLayout }: { layoutKey: string; setLayout: () => void }) => {
    return (
        <div className="grid-item" onClick={setLayout}>
            <div className="icon">
                <img src={layoutMap[layoutKey].icon} alt="" />
            </div>
            <div className="rest">
                <OliverText className="name" weight="medium-heavy" size="s" text={layoutMap[layoutKey].name} translatePrefix="layouts." />
            </div>
        </div>
    );
};

const PickLayout = ({
    isStartFromScratch,
    setIsStartFromScratch
}: {
    isStartFromScratch: boolean;
    setIsStartFromScratch: (isStartFromScratch: boolean) => void;
}) => {
    // const [isStartFromScratch, setIsstartFromScratch] = useState(false);
    const layoutType = useAppSelector(state => state.builder.currentLayer.type);
    const dispatch = useAppDispatch();

    const setLayout = (layoutKey: string) => {
        const layout = layoutMap[layoutKey]?.layout;
        if (!layout) return;
        dispatch(setLayoutToCurrentPage({ layout }));
        dispatch(setLeftInstance("addElement"));
        dispatch(openLeftSidebar());
    };

    if (isStartFromScratch) {
        return <AddElemPlus />;
    }

    return (
        <div className="layouts-page-wrapper" style={layoutType === "popups" ? { backgroundColor: "rgba(123, 140, 152, 0.3)" } : {}}>
            <div
                className="layouts-page-child"
                style={
                    layoutType === "popups"
                        ? { scale: "0.9", padding: "20px", boxShadow: "0px 15px 40px 0px rgba(37, 33, 33, 0.3)", borderRadius: "8px" }
                        : {}
                }
            >
                <div className="texts">
                    <div className="overlay-top" />
                    <OliverText text="How would you like to start?" translatePrefix="layouts." className="type1" />
                    <OliverText text="Let’s get you started the right way!" translatePrefix="layouts." className="type2" />
                </div>
                <div className="layouts-grid-wrapper">
                    <div className="blank">
                        <div className="blank-texts">
                            <OliverText text="Blank Canvas" translatePrefix="layouts." className="type3" />
                            <OliverText text="for technical people" translatePrefix="layouts." className="description" />
                            <Button text="Start from scratch" onClick={() => setIsStartFromScratch(true)} buttonStyle="secondary" size="fit" />
                        </div>
                    </div>
                    {/* <div className="start-from-template">
                        <div className="texts">
                            <OliverText text="Start with a template" translatePrefix="layouts." className="type1" />
                            <OliverText text="pick one" translatePrefix="layouts." className="description" style={{ textAlign: "start" }} />
                            <Button
                                text="See templates"
                                onClick={() => dispatch(setCurrentPopup("fullDesignSets"))}
                                buttonStyle="primary"
                                size="small"
                            />
                        </div>
                        <div className="image">
                            <img src="./templates-pile.svg" alt="" />
                        </div>
                    </div> */}
                    <div className="divider" />
                    {Object.keys(layoutMap).map(layoutKey => (
                        <LayoutItem key={layoutKey} layoutKey={layoutKey} setLayout={() => setLayout(layoutKey)} />
                    ))}
                </div>
                {layoutType !== "popups" && <div className="overlay" />}
            </div>
        </div>
    );
};

export default PickLayout;
